import React from 'react';

const GuestPicker = ({ occasionBooking, numberOfGuests, onChange, minimumNumberOfGuests }) => {
    const getGuests = () => {
        var options = [];
        var maxGuests = occasionBooking.occasionMaxGuests ? occasionBooking.occasionMaxGuests : 29;
        for (var i = Math.min(Math.max(1, minimumNumberOfGuests), maxGuests); i <= maxGuests; i++) {
            options.push(i.toString());
        }
        if(!occasionBooking.occasionMaxGuests) {            
            options.push("30+");
        }
        return options;
    }

    const handleGuestChange = (e) => {
        onChange(parseInt(e.target.value.split(' ')[0]));
    }

    const findGuestValue = () => {
        if (numberOfGuests == 1) {
            return "1 guest";
        }
        else if (numberOfGuests > 1 && numberOfGuests < 30)
        {
            return numberOfGuests + " guests";
        }
        else if (numberOfGuests >= 30) {
            return "30+ guests";
        }
        else {
            return "-";
        }
                
           
    }

    return (
        <React.Fragment>
            <label className='label'>Number of guests</label>
            <div className="w-full guests-dropdown">
                <select value={findGuestValue()} className="select guests-dropdown-select w-full" onChange={handleGuestChange}>
                    {getGuests().map(g => (
                        <option key={"guest" + g}>{g === "1" ? "1 guest" : g + " guests"}</option>
                    ))}
                </select>
                {occasionBooking == null && <p className="field-info">
                    Please include any children you're bringing in your total number of guests. You can tell us if you need a highchair later in the booking process.
                </p>}
            </div>
        </React.Fragment>
    );

}

export default GuestPicker;